import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import useResizeObserver from 'use-resize-observer'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Hero from '@/components/Feature/Hero'
import ArticleCard from '@/components/Articles/Card'
import { useResizer } from '../contexts/Resizer'

import { useStaticQuery, graphql } from 'gatsby'

let animations = {
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
}

const IndexPage = () => {
  const { ref, width, height } = useResizeObserver()
  const setArea = useResizer()

  const data = useStaticQuery(graphql`
    query mgposts($fields: [WpPostFieldsEnum] = date) {
      allWpPost(
        filter: {
          categories: {
            nodes: { elemMatch: { name: { eq: "MG-camila-andrade" } } }
          }
        }
        sort: { fields: $fields, order: ASC }
      ) {
        edges {
          node {
            slug
            title
            excerpt
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED, quality: 90)
                  }
                }
              }
            }
            postFormats {
              nodes {
                name
              }
            }
            date
          }
        }
      }
    }
  `)

  // console.log(typeof setArea, setArea)

  useEffect(() => {
    console.log(setArea, width, height)
    if (setArea) {
      console.log('setArea is finally setted!')
      let timeout = setTimeout(() => {
        setArea(area => {
          if (area.width !== width || area.height !== height) {
            return { width, height }
          } else {
            return area
          }
        })
      }, 150)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [width, height, setArea])

  return (
    <motion.div
      ref={ref}
      initial="exit"
      animate="enter"
      exit="exit"
      variants={animations}>
      <Layout>
        <SEO title="Un año de renovación" />
        <Hero
          titleLine1="Un año de"
          titleLine2="Renovación"
          subtitle="La firma del grupo SAIC enfrenta un nuevo desafío en el mercado nacional, luego de más de una década con un importador local, la marca comienza una nueva etapa, esta vez distribuida en mano de SAIC Motor, fabricante que representa a su marca a partir del 1 de enero de este año.<br />
          ¿Los desafíos? Mantenerse como una de las marcas favoritas por los chilenos, camino que se ha ido consolidando gracias a la renovación de su line up y su estrategia comercial. 
          "></Hero>

        {/* {Articles.map(article => (
        <ArticleCard key={article.title} {...article} />
      ))} */}
        {data.allWpPost.edges.map((edge, index) => (
          <ArticleCard
            key={edge.node.slug}
            odd={index % 2 === 0}
            title={edge.node.title}
            excerpt={edge.node.excerpt}
            slug={edge.node.slug}
            featuredImage={edge.node.featuredImage}
            type={
              edge.node.postFormats?.nodes[0]?.name === 'Video'
                ? 'video'
                : 'article'
            }
          />
        ))}
      </Layout>
    </motion.div>
  )
}

export default IndexPage
